module.exports = __webpack_public_path__ + "static/img/使い方・臨床等のお問い合わせ.694dec3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/使い方・臨床等のお問い合わせ.png
// module id = 7noJ
// module chunks = 0